import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtilities } from 'src/app/core/utilities/number.utilities';

@Pipe({name: 'currencyFormatter'})
export class CurrencyFormatterPipe implements PipeTransform {
  transform(value: number): string {
    return NumberUtilities.formatAsCurrency(value)
  }
}
